export default __webpack_public_path__ + "static/media/design.b0eb4a8e.png";